import React from 'react';
import Header from '@/kenwood/configurator/components/Header';
import HMCBanner from '@/kenwood/configurator/components/HMCBanner';
import OwnerBanner from '@/kenwood/configurator/components/OwnerBanner';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import useSetupStep1 from '@/kenwood/configurator/hooks/useSetupStep1';
import useProductData from '@/kenwood/configurator/hooks/useProductData';
import useClearCart from '@/kenwood/configurator/hooks/useClearCart';
import useConnectionData from '@/kenwood/configurator/hooks/useConnectionData';
import ProductsCarousel from '@/kenwood/configurator/components/ProductsCarousel';

const Step1 = () => {
  useSetupStep1();
  useClearCart();
  useProductData();
  useConnectionData();

  const [{ isOwner }] = useConfiguratorContext();

  return (
    <div>
      <Header step={1} />
      <div className='ken-configurator__step'>
        <div className='ken-configurator__step-one'>
          {isOwner ? <OwnerBanner /> : <HMCBanner />}
          <ProductsCarousel />
        </div>
      </div>
    </div>
  );
};

export default Step1;
